import { serverConfig } from '@/config/server.config'
import { RegistrationStatus, type BaseResponse } from '@/types/'

export async function fetchWithAuthCheck<T>(
  path: string,
  init?: RequestInit,
): Promise<BaseResponse<T>> {
  try {
    const response = await fetch(
      `${serverConfig.digitalCommunicationsApiUrl}${path}`,
      {
        credentials: 'include',
        ...init,
        headers: {
          'Content-Type': 'application/json',
          ...init?.headers,
        },
      },
    )

    if (!response.ok) {
      return {
        data: null,
        needsToLogin: false,
        isSuccess: false,
        registrationStatus: RegistrationStatus.Unknown,
      }
    }

    const result: BaseResponse<T> = await response.json()

    if (result.needsToLogin) {
      const { redirectToLogin } = await import('@/services/redirectToLogin')
      await redirectToLogin()
    }

    return result
  } catch (_) {
    return {
      data: null,
      needsToLogin: false,
      isSuccess: false,
      registrationStatus: RegistrationStatus.Unknown,
    }
  }
}
